import { LitElement, html } from "lit-element";
import { property } from "lit/decorators.js";

class ForgotPassword extends LitElement {
  errors: any = {};
  @property({ type: String }) message: any;

  static get properties() {
    return {
      errors: { type: Object },
    };
  }

  render() {
    return html`
      <div class="auth-container">
        <h1>Forgot Password</h1>

        ${this.message
          ? html`<div class="form-success-message">${this.message}</div>`
          : html`
              <form @submit="${this.handleSubmit}">
                <div
                  class="form-group ${this.errors.field === "email"
                    ? "has-error"
                    : ""}"
                >
                  <label for="email">Email</label>
                  <input type="text" name="email" />
                  ${this.errors.field === "email"
                    ? html`<span class="form-error-message"
                        >${this.errors.error}</span
                      >`
                    : ""}
                </div>

                <div class="form-submit-section">
                  <button type="submit" class="form-submit form-button">
                    <span>Send</span>
                  </button>
                </div>
              </form>
            `}

        <p class="form-message">
          Remember your password?
          <a href="/" class="login-link">Login</a>
        </p>
      </div>
    `;
  }

  handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(event.target);

    fetch(`${process.env.BASE_API_URL}/forgot-password`, {
      method: "POST",
      body: JSON.stringify({ email: formData.get("email") }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          this.errors = data;
        } else {
          this.message = data.message || "Registration successful!";
        }
      })
      .catch((error) => {
        console.error("Error during login:", error);
        alert("An error occurred during login. Please try again later.");
      });
  }

  protected createRenderRoot() {
    return this;
  }
}

customElements.define("forgot-password-page", ForgotPassword);
